var _BindingsNamespace_instances, _BindingsNamespace_getDataBindingConnection, _BindingsNamespace_parseConnectionConfig, _BindingsNamespace_hasBoundDataBindingController, _BindingsNamespace_isBindableComponent, _BindingsNamespace_reconnectWithUpdatedConfig;
import { __classPrivateFieldGet } from "tslib";
import { PrivateAPINamespace } from '../PrivateAPINamespace';
// TODO: get from cms-platform-integration package
const bindableComponentTypes = [
    'platform.builder.6a30caff-5dc3-4e4c-ba70-19db988f5830_4220f51c-7462-49f6-7352-14219c165b28',
    'platform.builder.6a30caff-5dc3-4e4c-ba70-19db988f5830_0bfa7aab-081b-431b-adb2-1b1062e8f21a',
    'platform.builder.6a30caff-5dc3-4e4c-ba70-19db988f5830_4190f51c-3836-49f6-8114-96219c165b29',
];
export class BindingsNamespace extends PrivateAPINamespace {
    constructor() {
        super(...arguments);
        _BindingsNamespace_instances.add(this);
        this.bindingType = 'dataBinding';
    }
    create(compRef, { role, config, dataItemId, }) {
        const dataConnection = __classPrivateFieldGet(this, _BindingsNamespace_instances, "m", _BindingsNamespace_getDataBindingConnection).call(this, compRef);
        if (!dataConnection?.config) {
            return false;
        }
        const connectionConfig = {
            type: this.bindingType,
            byItem: __classPrivateFieldGet(this, _BindingsNamespace_instances, "m", _BindingsNamespace_parseConnectionConfig).call(this, dataConnection.config) ?? {},
        };
        if (connectionConfig?.byItem?.[dataItemId]) {
            return false;
        }
        connectionConfig.byItem[dataItemId] = JSON.stringify(config);
        __classPrivateFieldGet(this, _BindingsNamespace_instances, "m", _BindingsNamespace_reconnectWithUpdatedConfig).call(this, compRef, dataConnection, role, connectionConfig);
        return true;
    }
    delete(compRef, dataItemId) {
        const dataConnection = __classPrivateFieldGet(this, _BindingsNamespace_instances, "m", _BindingsNamespace_getDataBindingConnection).call(this, compRef);
        if (!dataConnection?.config) {
            return;
        }
        const controllerConfig = __classPrivateFieldGet(this, _BindingsNamespace_instances, "m", _BindingsNamespace_parseConnectionConfig).call(this, dataConnection.config);
        if (!controllerConfig) {
            return;
        }
        if (!controllerConfig.byItem?.[dataItemId]) {
            return;
        }
        const { [dataItemId]: removed, ...remainingItems } = controllerConfig.byItem;
        if (Object.keys(remainingItems).length === 0) {
            controllerConfig.byItem = {};
        }
        else {
            controllerConfig.byItem = remainingItems;
        }
        return __classPrivateFieldGet(this, _BindingsNamespace_instances, "m", _BindingsNamespace_reconnectWithUpdatedConfig).call(this, compRef, dataConnection, dataConnection.role, controllerConfig);
    }
    update(compRef, dataItemId, { config, role, }) {
        const dataConnection = __classPrivateFieldGet(this, _BindingsNamespace_instances, "m", _BindingsNamespace_getDataBindingConnection).call(this, compRef);
        if (!dataConnection?.config) {
            return;
        }
        const connectionConfig = __classPrivateFieldGet(this, _BindingsNamespace_instances, "m", _BindingsNamespace_parseConnectionConfig).call(this, dataConnection.config);
        if (!connectionConfig?.byItem?.[dataItemId]) {
            return;
        }
        connectionConfig.byItem[dataItemId] = JSON.stringify(config);
        return __classPrivateFieldGet(this, _BindingsNamespace_instances, "m", _BindingsNamespace_reconnectWithUpdatedConfig).call(this, compRef, dataConnection, role || dataConnection.role, connectionConfig);
    }
    get(dataItemId, compRef) {
        const dataConnection = __classPrivateFieldGet(this, _BindingsNamespace_instances, "m", _BindingsNamespace_getDataBindingConnection).call(this, compRef);
        if (!dataConnection?.config) {
            return null;
        }
        const connectionConfig = __classPrivateFieldGet(this, _BindingsNamespace_instances, "m", _BindingsNamespace_parseConnectionConfig).call(this, dataConnection.config);
        if (!connectionConfig?.byItem?.[dataItemId]) {
            return null;
        }
        return JSON.parse(connectionConfig.byItem[dataItemId]);
    }
    async canCreateBindingsProvider(compRef) {
        const componentType = this.ps.ds.components.getType(compRef);
        return (__classPrivateFieldGet(this, _BindingsNamespace_instances, "m", _BindingsNamespace_isBindableComponent).call(this, componentType) &&
            __classPrivateFieldGet(this, _BindingsNamespace_instances, "m", _BindingsNamespace_hasBoundDataBindingController).call(this, compRef));
    }
    openDataBindingPanel(dataItemId, panelId) {
        return this.ps.hostAPI.editor.openPanel(panelId, {
            dataItemId,
        });
    }
}
_BindingsNamespace_instances = new WeakSet(), _BindingsNamespace_getDataBindingConnection = function _BindingsNamespace_getDataBindingConnection(compRef) {
    const connections = this.ps.ds.platform.controllers.connections.get(compRef);
    const dataBindingConnection = connections.find((connection) => {
        try {
            return JSON.parse(connection.config).type === this.bindingType;
        }
        catch {
            return false;
        }
    });
    return dataBindingConnection;
}, _BindingsNamespace_parseConnectionConfig = function _BindingsNamespace_parseConnectionConfig(configString) {
    try {
        return configString ? JSON.parse(configString) : null;
    }
    catch {
        return null;
    }
}, _BindingsNamespace_hasBoundDataBindingController = function _BindingsNamespace_hasBoundDataBindingController(compRef) {
    const controllers = this.ps.ds.platform.controllers.getAvailableScopedControllers(compRef);
    return controllers.some((controller) => controller.type === 'platform.components.AppController');
}, _BindingsNamespace_isBindableComponent = function _BindingsNamespace_isBindableComponent(componentType) {
    return bindableComponentTypes.includes(componentType);
}, _BindingsNamespace_reconnectWithUpdatedConfig = function _BindingsNamespace_reconnectWithUpdatedConfig(compRef, dataConnection, role, connectionConfig) {
    this.ps.ds.platform.controllers.connections.disconnect(compRef, dataConnection.controllerRef, role);
    return this.ps.ds.platform.controllers.connections.connect(compRef, dataConnection.controllerRef, role, JSON.stringify(connectionConfig), true);
};
BindingsNamespace.namespace = 'bindings';
//# sourceMappingURL=BindingsNamespace.js.map